var RADIAN = Math.PI / 180;
var toRadian = function (degree) {
    return RADIAN * degree;
};
export default toRadian;
//# sourceMappingURL=to-radian.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/to-radian.js
// module id = 529
// module chunks = 3